import React, { Component } from 'react';
import { iconForField } from '../../../common/custom/icon-library';
import CustomSelect from '../../home/collections/CustomSelect';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
const orderOptions = [
  { label: '- Select Order -', value: '' },
  { label: 'ASC', value: 'ASC' },
  { label: 'DESC', value: 'DESC' },
];
export default class ConFieldDetails extends Component {
  state = {
    selectedField: { label: '- Select Field -', value: '' },
    selectedFieldError: '',
    orderBy: { label: '- Select Order -', value: '' },
  };

  componentDidMount() {
    const { selectedField } = this.state;
    const { fieldOptions, field } = this.props;
    if (selectedField) {
      const selField = fieldOptions.find(sField => sField.value === field.field.value);
      const selOrder = orderOptions.find(sField => sField.value === field.order.value);
      console.log('selField', selField, selOrder);
      this.setState({
        selectedField: selField ? selField : null,
        orderBy: selOrder ? selOrder : null,
      });
    }
  }

  customSelectHandleChange = (name, value) => {
    this.setState({ selectedField: value, selectedFieldError: '' });
  };
  saveConField = () => {
    const { selectedField } = this.state;
    const { savePConField } = this.props;
    if (!selectedField || !selectedField.value) {
      this.setState({ selectedFieldError: "Field can't be blank" });
    }
    savePConField(field.id, { field: selectedField.value, order: orderBy.value });
  };
  resetConField = () => {
    const { field } = this.props;
    this.setState({ selectedFieldError: '', orderBy: { label: 'ASC', value: 'ASC' } });
  };
  showSaveBtn = () => {
    const { selectedField, orderBy } = this.state;
    const { field } = this.props;
    console.log('field :>> ', field, selectedField, orderBy);
    let notSaved = field.field === selectedField.value;
    notSaved = field.order === orderBy.value;
    console.log('notSaved', notSaved);
    if (!notSaved) {
      return (
        <button
          type="button"
          onClick={this.saveConField}
          className="btn btn-sm btn-theme-submit"
          title="Save Index"
        >
          <i className="wb webconnect-save-regular"></i>&nbsp;Save
        </button>
      );
    }
    return '';
  };
  render() {
    const { selectedField, orderBy, selectedFieldError } = this.state;
    const { fieldOptions, setFieldValue, setFieldTouched } = this.props;
    return (
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-5 col-lg-5 col-sm-12 col-xs-12">
            <CustomInputWithIcon title="Select Field" icon={iconForField('select')} required={true}>
              <CustomSelect
                name="selectedField"
                isMulti={false}
                value={selectedField}
                options={fieldOptions}
                onChangeValue={this.customSelectHandleChange}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                placeholder="Field"
              />
              {selectedFieldError && <p className="text-error">{selectedFieldError}</p>}
            </CustomInputWithIcon>
          </div>
          <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12">
            <CustomInputWithIcon
              title="Select OrderBy"
              icon={iconForField('select')}
              required={true}
            >
              <CustomSelect
                name="orderBy"
                isMulti={false}
                value={orderBy}
                options={orderOptions}
                onChangeValue={(name, value) => this.setState({ orderBy: value })}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                placeholder="orderBy"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 text-right">
            {this.showSaveBtn()}
            &nbsp;
            <button
              type="button"
              onClick={this.resetConField}
              className="btn btn-sm btn-theme-delete"
              title="Delete Index"
            >
              <i className="wb webconnect-trash-regular"></i>&nbsp;Remove
            </button>
          </div>
        </div>
      </div>
    );
  }
}
